import { gql } from "@/__generated__/gql";

export const BULK_MESSAGE_QUERY = gql(`
  query BulkMessage(
    $bulkMessageId: ID!
  ) {
    node(id: $bulkMessageId) {
      ... on BulkMessage {
        id
        __typename
        name
        createdAt
        createdBy {
          id
          firstName
          lastName
          uuid
        }
        campaignType
        draft
        filters {
          assignedCounselorIds
          studentTypes
          funnelStates
          locations
          interestIds
          majorIds
          studentSource
          commitIndexes
          userIds
          firstTimeMessageRecipients
          startTerms {
            semester
            year
          }
        }
        messageParts {
          edges {
            node {
              id
              body {
                ... on MessagePartText {
                  text
                }
                ... on MessagePartAttachment {
                  url
                  type
                }
              }
            }
          }
        }
        senderType
        startSendingAt
        stopSendingAt
        sentTo(first: 6) {
          edges {
            node {
              firstName
              lastName
              profilePhoto {
                url(size: 24)
              }
            }
          }
          totalCount
        }
        sentFrom {
          id
          firstName
          email
          lastName
          profilePhoto {
            id
            url(size: 24)
          }
        }
      }
    }
  }
`);
